import { render, staticRenderFns } from "./Abroad.vue?vue&type=template&id=5ca7cdfe&scoped=true&"
import script from "./Abroad.vue?vue&type=script&lang=js&"
export * from "./Abroad.vue?vue&type=script&lang=js&"
import style0 from "./Abroad.vue?vue&type=style&index=0&id=5ca7cdfe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca7cdfe",
  null
  
)

export default component.exports